import { render, staticRenderFns } from "./Statistica.vue?vue&type=template&id=37f1ad72&scoped=true&"
import script from "./Statistica.vue?vue&type=script&lang=js&"
export * from "./Statistica.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f1ad72",
  null
  
)

export default component.exports